import {
  faChevronRight,
  faHeart,
  faStar,
  faTags,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { printPrice } from "../../utils/functions";

interface ProductCartInterface {
  name: string;
  price: number;
  quantity: number;
  images?: string;
    id: number;
    description: string;
}

interface Props {
  product: ProductCartInterface;
  onClick: Function;
  priceSystemId: number;
  cardWidth: string;
  addCart: Function;
}

export const CardProduct = ({
  product,
  onClick, 
  cardWidth,
  addCart,
}: Props) => {
  return (
    <>
      <div
        className={`h-80 ${cardWidth}   rounded-lg scrollbar-hide  overflow-hidden   shadow-md inline-block  cursor-pointer  ease-in-out duration-300`}
      >
        <div className="h-40  bg-slate-200 group-hover:opacity-75 ">
          <img
            src={product.images}
            alt={product.name}
            onClick={() => onClick(product)}
            className="h-full w-full object-cover object-center sm:h-full sm:w-full"
          />
        </div>

        <div className="flex flex-1 w-full whitespace-nowrap  flex-col space-y-1 p-2">
          <h3
            className="text-lg truncate font-medium text-slate-900"
            onClick={() => onClick(product)}
          >
            {product.name}
          </h3>
          <p className="text-sm truncate h-5 -mt-2 text-slate-500">
            {" "}
            {product.description}
          </p>
          <div className="flex flex-row flex-nowrap ">
           
            <h5
              className={`text-base  font-medium  text-slate-900 `}
            >
             {printPrice(product.price)} CUP
            </h5>
          </div>
          <button
            type="button"
            onClick={() => {
              addCart(product);
            }}
            className="w-full overflow-hidden truncate   inline-flex  items-center   justify-center text-center rounded-md border border-transparent bg-orange-100  py-2 text-sm font-medium text-orange-700 hover:bg-orange-200 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          >
            Añadir a la bolsa
          </button>
        </div>
      </div>
    </>
  );
};
